/**
 * Chrome Translate і частина розширень переписують текстові вузли поза React.
 * Наступний commit тоді падає на insertBefore/removeChild і валить увесь застосунок.
 * Якщо вузол уже не дитина цього батька — пропускаємо операцію.
 */
export function installDomMutationGuard(): void {
    if (typeof Node !== 'function' || !Node.prototype) return;

    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function removeChild<T extends Node>(this: Node, child: T): T {
        if (child.parentNode !== this) {
            console.error('Cannot remove a child from a different parent', child, this);
            return child;
        }
        return originalRemoveChild.call(this, child) as T;
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function insertBefore<T extends Node>(
        this: Node,
        newNode: T,
        referenceNode: Node | null,
    ): T {
        if (referenceNode && referenceNode.parentNode !== this) {
            console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
            return newNode;
        }
        return originalInsertBefore.call(this, newNode, referenceNode) as T;
    };
}
